/**
 * Multi-tab conflict detection for cloud saves.
 *
 * Each successful PUT returns the authoritative new server version. A normal,
 * uncontended save advances the version by exactly one (`lastKnown + 1`). If the
 * server comes back higher than that, another tab (or device) wrote in between —
 * the non-blocking "changed in another tab" warning. v1 is last-write-wins with
 * no merge, so this is a pure comparison used only to surface the warning.
 */
export const isVersionConflict = (
  lastKnownVersion: number | null,
  serverVersion: number | null,
): boolean => {
  if (lastKnownVersion === null || serverVersion === null) {
    return false;
  }
  return serverVersion > lastKnownVersion + 1;
};
